import { createSlice } from "@reduxjs/toolkit";
import { RequestResults } from "../../common/RequestStatus";
import { IAuthState, IUserRole } from "./IAuthState";
import { forgotPasswordThunkAsync, getProfileInfoThunkAsync, signInThunkAsync, updateAdminProfileThunkAsync } from "./authAsyncThunk";
import { toast } from "react-toastify";
import { message } from "antd";
import { setAuthToken } from "../../../utils/constants/api";

const initialState: IAuthState = {
  authStatus: RequestResults.idle,
  authenticated: false,
  userAuthInfo: null,
};

// --------------------------------

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuth(state) {
      localStorage.clear();
      state.authenticated = false;
      state.authStatus = RequestResults.idle;
      state.userAuthInfo = null;
    },
    setAuthenticated(state, action) {
      state.authenticated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInThunkAsync.pending, (state) => {
      // state.authStatus = RequestResults.pending;
    });
    builder.addCase(signInThunkAsync.fulfilled, (state, action) => {
      const user = action.payload;
      if (user.accessToken) {
        setAuthToken(user.accessToken);
      } else {
        message.error("Something went wrong, please try again later!");
        throw new Error("Access token is undefined");
      }
      if (user.refreshToken) localStorage.setItem("refreshToken", user.refreshToken);
      state.authenticated = true;
      toast.success("Login successful", { position: "top-right" });
    });
    builder.addCase(signInThunkAsync.rejected, (state) => {
      state.authStatus = RequestResults.failed;
      state.authenticated = false;
    });

    builder.addCase(forgotPasswordThunkAsync.pending, (state) => {});
    builder.addCase(forgotPasswordThunkAsync.fulfilled, (state, action) => {});
    builder.addCase(forgotPasswordThunkAsync.rejected, (state) => {});

    // Get User profile
    builder.addCase(getProfileInfoThunkAsync.pending, (state) => {
      state.authStatus = RequestResults.pending;
    });
    builder.addCase(getProfileInfoThunkAsync.fulfilled, (state, action) => {
      const user = action.payload;
      if (!user) {
        state.authenticated = false;
      } else {
        state.authenticated = true;
      }
      state.userAuthInfo = action.payload;
      state.authStatus = RequestResults.success;
    });
    builder.addCase(getProfileInfoThunkAsync.rejected, (state) => {
      state.authStatus = RequestResults.failed;
      state.authenticated = false;
    });
    builder.addCase(updateAdminProfileThunkAsync.pending, (state) => {});
    builder.addCase(updateAdminProfileThunkAsync.fulfilled, (state, action) => {
      const role = state?.userAuthInfo?.role;
      state.userAuthInfo = { ...state.userAuthInfo, ...action.payload, role: role as IUserRole };
      toast.success("Profile updated successfully", { position: "top-right" });
    });
    builder.addCase(updateAdminProfileThunkAsync.rejected, (state, action) => {
      if (state.userAuthInfo) {
        state.userAuthInfo = { ...state.userAuthInfo };
      }
      toast.error((action?.payload as string) || "Failed to update profile", { position: "top-right" });
    });
  },
});

// Export Actions
export const { resetAuth, setAuthenticated } = authSlice.actions;

export default authSlice.reducer;
